import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { DepotUpdated, UpdateDepot, updateDepot } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useEditDepot = (
  id: number,
  options: UseMutationOptions<DepotUpdated, unknown, UpdateDepot, unknown>
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (values: UpdateDepot) =>
      extractData(updateDepot({ body: { ...values, id } })),
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['depots'],
      });
      options.onSuccess?.(...args);
    },
  });
};
